import React from 'react';

import OverflowText from '~/components/OverflowText';
import { Skeleton } from '~/components/utils';
import grid from '~/styles/grid';

import { ProcessStatus } from '../../getStatus';
import StatusSubtitle, { StatusSubtitleProps } from './StatusSubtitle';
import {
  Container,
  Content,
  EmptyNameLabel,
  InstanceButton,
  MenuContainer,
  SkeletonContent,
  InstanceImage,
} from './styles';

export interface InstanceLink {
  id: string;
  name: string;
  state: ProcessStatus;
  type: string;
}

export interface MenuInstancesProps {
  handleChangeActiveInstance: (newInstance: InstanceLink) => void;
  statusProps: StatusSubtitleProps;
  activeInstance?: InstanceLink;
  instances?: Array<InstanceLink>;
  loading?: boolean;
}

const MenuInstances: React.FC<MenuInstancesProps> = ({
  activeInstance,
  handleChangeActiveInstance,
  statusProps,
  instances,
  loading,
}) => {
  const renderMenu = () => (
    <MenuContainer>
      {instances?.map((instance) => (
        <Content key={instance.id}>
          <InstanceButton
            key={instance.id}
            isActive={instance.id === activeInstance?.id}
            onClick={() => handleChangeActiveInstance(instance)}
          >
            <InstanceImage
              src={statusProps.getStatus(instance.state).image}
              alt={instance.name}
            />
            <OverflowText title={instance.name} lines={2}>
              {instance.name ?? (
                <EmptyNameLabel>Nome não definido</EmptyNameLabel>
              )}
            </OverflowText>
          </InstanceButton>
        </Content>
      ))}
    </MenuContainer>
  );

  const renderSkeleton = () => (
    <MenuContainer>
      {Array.from(Array(10)).map((_, index) => (
        <SkeletonContent key={`menu-${index}`}>
          <Skeleton
            variant="circle"
            style={{ height: grid.md, width: grid.md }}
          />
          <Skeleton variant="text" style={{ height: grid.md, width: '100%' }} />
        </SkeletonContent>
      ))}
    </MenuContainer>
  );

  return (
    <Container>
      {loading ? renderSkeleton() : renderMenu()}
      <StatusSubtitle {...statusProps} />
    </Container>
  );
};

export default MenuInstances;
